module.exports = __webpack_public_path__ + "static/media/computerMove.54f4ee67.wav";